'use client';

import React from 'react';
import { StrategyListGenerator } from '../index';
import { STRATEGY_ALLOWED_TYPES } from 'src/components/DynamicCriteriaGenerator/constants';
import { LOCATION } from 'src/hooks/filters/constants';
import { StrategyConfigProps } from 'src/components/Strategy/config';

const NotReferringConfiguration: React.FC<StrategyConfigProps> = ({
  location = LOCATION.STRATEGY,
}) => {
  // Edit mode display
  return (
    <div className="flex flex-col gap-4">
      <StrategyListGenerator
        allowedTypes={STRATEGY_ALLOWED_TYPES}
        strategyType="NOT_REFERRING"
        location={location}
      />
    </div>
  );
};

export default NotReferringConfiguration;
